import React from "react";

const HeartIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1632_271" x="0" y="0" width="25" height="25">
        <rect width="25" height="25" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1632_271)">
        <path
          d="M12.5002 21.858L11.2849 20.7642C9.47355 19.1149 7.97759 17.6913 6.79704 16.4934C5.61648 15.2955 4.67609 14.2234 3.97587 13.2772C3.27562 12.331 2.78517 11.4702 2.50451 10.6948C2.22383 9.91931 2.0835 9.13227 2.0835 8.33366C2.0835 6.74802 2.6159 5.42278 3.68071 4.35796C4.74554 3.29315 6.06498 2.76074 7.63904 2.76074C8.5997 2.76074 9.4967 2.98065 10.33 3.42046C11.1634 3.86028 11.8867 4.49107 12.5002 5.31283C13.183 4.45635 13.9324 3.81688 14.7484 3.39441C15.5644 2.97197 16.4353 2.76074 17.3613 2.76074C18.9353 2.76074 20.2548 3.29315 21.3196 4.35796C22.3844 5.42278 22.9168 6.74802 22.9168 8.33366C22.9168 9.13227 22.7765 9.91931 22.4958 10.6948C22.2152 11.4702 21.7247 12.331 21.0245 13.2772C20.3242 14.2234 19.3838 15.2955 18.2033 16.4934C17.0227 17.6913 15.5268 19.1149 13.7154 20.7642L12.5002 21.858Z"
          fill="#D04040"
        />
      </g>
    </svg>
  );
};

export default HeartIcon;
